export const globalSettingsIssuesWorkflowsImportRoute = {
	name: 'global-settings-issues-workflows-import',
	path: '/plugins/servlet/wfshare-(import|export)',
};
